import { NgModule, Component, OnChanges, Input, ChangeDetectionStrategy } from '@angular/core';

@Component({
	selector: 'tree-level-wedge',
	standalone: false,
	template: /*html*/`
		@if (level > 0 && prefix) {
			{{prefix}}
		}
		@for (c of range; track c) {
			{{wedge}}
		}
		@if (level > 0 && suffix) {
			{{suffix}}
		}
	`,
	providers: [],
	changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TreeLevelWedgeComponent implements OnChanges {

	@Input() level: number = 0;
	@Input() wedge: string = ' • ';
	@Input() prefix: string = '';
	@Input() suffix: string = ' ';

	range: number[] = [];

	constructor() {

	}

	ngOnChanges(changes: any) {
		if (
			typeof changes.level != 'undefined'
			&& changes.level.currentValue != changes.level.previousValue
			&& !Number.isNaN(changes.level.currentValue)
		) {
			this.range = new Array(changes.level.currentValue);
		}
	}

}
